import NiceModal from '@ebay/nice-modal-react';
import { enqueueSnackbar } from 'notistack';
import { prop } from 'ramda';
import { createAction } from 'redux-actions';

import { resetForm } from '@gef-ui/form-core/stream/transfer/control';
import { getMessage } from '@gef-ui/localization/messages';

import { campaignStates } from 'constants/campaigns';
import { codelists } from 'constants/codelists';
import MODALS from 'constants/modals';
import dialog from 'features/common/dialog';
import fetch from 'features/common/fetch';
import campaigns from 'features/views/campaigns';
import contacts from 'features/views/contacts';
import user from 'features/views/user';
import { getCodelistByName, trimFormData } from 'utils';

import * as types from './actionTypes';
import { dialogError } from './constants';
import { CONTACT_TAKE_FORM_NAME } from './form';
import { getSelectedContact } from './selectors';
import { checkAllowedSearchCombinations } from './utils';

const loadContacts = contacts.actions.loadContacts('take');
const reloadContactList = contacts.actions.reload('list');

export const reset = createAction(types.RESET);
export const selectContact = createAction(types.SELECT_CONTACT, (id) => ({ id }));

export const resetCriteria =
	() =>
	(dispatch, getState, { sendControlNext }) => {
		dispatch(reset());
		dispatch(dialog.actions.close(dialogError));
		dispatch(fetch.actions.clearFetchStore(`${fetch.constants.urls.contactList}.take`));
		dispatch(contacts.actions.resetContacts('take'));
		sendControlNext(CONTACT_TAKE_FORM_NAME, resetForm());
	};

export const submitForm =
	() =>
	async (dispatch, getState, { getFormData }) => {
		const data = await getFormData(CONTACT_TAKE_FORM_NAME);
		const formData = trimFormData(data);
		const contactStatesCodelist = getCodelistByName(codelists.solutionState)(getState());
		const contactState = contactStatesCodelist
			.filter((state) => Number(state.id) === 2 || state.stateType === 'FAIL' || state.stateType === 'PROGRESS')
			.map((state) => state.id);

		// check for combinations
		if (!checkAllowedSearchCombinations(formData)) {
			return dispatch(dialog.actions.open(dialogError));
		}

		// reset state and load new data
		dispatch(reset());
		dispatch(dialog.actions.close(dialogError));
		dispatch(
			loadContacts({
				...formData,
				contactState,
				campaignStateIds: [campaignStates.RUNNING],
				searchAllCampaigns: true,
				filterNominations: true,
			}),
		);
	};

export const takeContact = () => (dispatch, getState) => {
	const { id, campaign = {} } = getSelectedContact(getState());
	const fetchStore = fetch.selectors.getFetchStore(getState());
	const campaignListRequest = prop('/campaign/list', fetchStore);
	const queryParams = campaignListRequest.contacts.lastRequest.queryParams;

	dispatch(
		fetch.actions.put(fetch.constants.urls.contactDetail, {
			uniqueReqID: 'take',
			replaceParams: { id },
			body: {
				campaignWaveId: campaign.id,
				canChangeSolver: true,
				userRole: user.selectors.getCurrentRole(getState()),
			},
			onSuccess: [
				() => () => {
					dispatch(user.actions.fetchAdditionalUserInfo());
					dispatch(reloadContactList);
					dispatch(campaigns.actions.load('contacts')(queryParams));
					enqueueSnackbar(getMessage('toastr:approveTakeContact'), { variant: 'success' });
					NiceModal.hide(MODALS.contact_take);
				},
			],
		}),
	);
};
